import { render, staticRenderFns } from "./RoundIcon.vue?vue&type=template&id=605933a4&scoped=true&"
import script from "./RoundIcon.vue?vue&type=script&lang=ts&"
export * from "./RoundIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RoundIcon.vue?vue&type=style&index=0&id=605933a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605933a4",
  null
  
)

export default component.exports